document.addEventListener('DOMContentLoaded', () => {
  // 機能: 選択課題管理画面の制御
  // 概要: ・「全選択」チェックボックスの操作に連動して、個別チェックボックスの状態を変更する。
  //       ・個別チェックボックスの操作に連動して、「全選択」チェックボックスの状態を更新する。
  //       ・チェック状態の課題の見積工数をリアルタイムで合計し、表示する。
  //       ・カスタム工数の入力値が変更された場合も、リアルタイムで合計に反映する。

  // ターゲット要素のセレクタ定義
  const TABLE_SELECTOR = '.js-userPractices';
  const ALL_CHECKBOX_SELECTOR = '.js-allCheckbox';
  const INDIVIDUAL_CHECKBOX_SELECTOR = '.js-checkbox';
  const ESTIMATED_WORKLOAD_INPUT_SELECTOR = '.js-estimatedWorkload';
  const TOTAL_ESTIMATED_WORKLOAD_DISPLAY_SELECTOR = '.js-totalEstimatedWorkload';
  const TOTAL_PRACTICE_ESTIMATED_WORKLOAD_DISPLAY_SELECTOR = '.js-totalPracticeEstimatedWorkload';

  const userPracticesTable = document.querySelector(TABLE_SELECTOR);

  // テーブル要素が存在する場合のみ処理を実行
  if (userPracticesTable) {
    const allCheckbox = userPracticesTable.querySelector(ALL_CHECKBOX_SELECTOR);
    const individualCheckboxes = userPracticesTable.querySelectorAll(INDIVIDUAL_CHECKBOX_SELECTOR);
    const totalWorkloadDisplay = userPracticesTable.querySelector(TOTAL_ESTIMATED_WORKLOAD_DISPLAY_SELECTOR);
    const totalPracticeWorkloadDisplay = userPracticesTable.querySelector(TOTAL_PRACTICE_ESTIMATED_WORKLOAD_DISPLAY_SELECTOR);
    const workloadInputs = userPracticesTable.querySelectorAll(ESTIMATED_WORKLOAD_INPUT_SELECTOR);

  /**
   * 渡された行(tr)から、カスタム工数またはデフォルト工数を数値として取得します。
   * @param {HTMLElement} row - テーブルのtr要素
   * @returns {number} - 工数の数値
   */
  const getWorkloadFromRow = (row) => {
    const workloadInput = row.querySelector(ESTIMATED_WORKLOAD_INPUT_SELECTOR);
    if (!workloadInput) return 0;

    if (workloadInput.tagName === 'INPUT') {
      const parsedValue = parseFloat(workloadInput.value);
      // isNaN(parsedValue) は、valueが空文字や"abc"などの場合にtrueになる
      return !isNaN(parsedValue) ? parsedValue : (parseFloat(workloadInput.placeholder) || 0);
    } else if (workloadInput.tagName === 'TD') {
      return parseFloat(workloadInput.textContent) || 0;
    }
    return 0;
  };

  /**
   * 渡された行(tr)から、デフォルトの工数を数値として取得します。
   * @param {HTMLElement} row - テーブルのtr要素
   * @returns {number} - デフォルト工数の数値
   */
  const getDefaultWorkloadFromRow = (row) => {
    const workloadInput = row.querySelector(ESTIMATED_WORKLOAD_INPUT_SELECTOR);
    // inputのplaceholderか、tdのtextContentから値を取得
    const value = workloadInput?.placeholder || workloadInput?.textContent || '0';
    return parseFloat(value) || 0;
  };

  /**
   * 差分表示用の要素のテキストとスタイルを更新します。
   * @param {number} totalWorkload - カスタム工数の合計
   * @param {number} totalPracticeWorkload - デフォルト工数の合計
   */
  const updateDiffDisplay = (totalWorkload, totalPracticeWorkload) => {
    if (!totalPracticeWorkloadDisplay) return;

    const diffWorkload = totalWorkload - totalPracticeWorkload;
    const workloadNumber = parseFloat(diffWorkload.toFixed(2));

    let displayText = `(${workloadNumber})`;
    totalPracticeWorkloadDisplay.classList.remove('is-warning');

    if (workloadNumber > 0) {
      displayText = `(+${workloadNumber})`;
    } else if (workloadNumber < 0) {
      displayText = `(${workloadNumber})`;
      totalPracticeWorkloadDisplay.classList.add('is-warning');
    }

    totalPracticeWorkloadDisplay.textContent = displayText;
  };

  /**
   * チェックされている課題の見積工数を合計し、関連する全ての表示を更新します。
   */
  const calculateTotalWorkload = () => {
    // disabledでないチェックボックスを持つ行だけを対象にする
    const rows = Array.from(individualCheckboxes).map(cb => cb.closest('tr'));

    // 1. チェックされている行のカスタム工数を合計
    const totalWorkload = rows
      .filter(row => row.querySelector(INDIVIDUAL_CHECKBOX_SELECTOR)?.checked)
      .reduce((sum, row) => sum + getWorkloadFromRow(row), 0);

    // 2. 全ての行のデフォルト工数を合計
    const totalPracticeEstimatedWorkload = rows.reduce((sum, row) => sum + getDefaultWorkloadFromRow(row), 0);

    // 3. 合計工数の表示を更新
    if (totalWorkloadDisplay) {
      totalWorkloadDisplay.textContent = parseFloat(totalWorkload.toFixed(2));
    }

    // 4. 差分表示を更新
    updateDiffDisplay(totalWorkload, totalPracticeEstimatedWorkload);
  };

    /**
     * 個別のチェックボックスの状態を監視し、全選択チェックボックスの状態を調整します。
     */
    const updateAllCheckboxState = () => {
      if (!allCheckbox) return;

      const allIndividualChecked = Array.from(individualCheckboxes)
        .filter(checkbox => !checkbox.disabled)
        .every(checkbox => checkbox.checked);

      allCheckbox.checked = allIndividualChecked;
    };

    /**
     * 「全選択」チェックボックスの状態に応じて、全ての個別チェックボックスを操作します。
     */
    const handleAllCheckboxChange = () => {
      const isAllChecked = allCheckbox.checked;
      individualCheckboxes.forEach(checkbox => {
        if (!checkbox.disabled) {
          checkbox.checked = isAllChecked;
        }
      });
      calculateTotalWorkload();
    };

    // --- イベントリスナー登録 ---

    // 「全選択」チェックボックスの変更を監視
    if (allCheckbox) {
      allCheckbox.addEventListener('change', handleAllCheckboxChange);
    }

    // 各課題の個別チェックボックスの変更を監視
    individualCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        calculateTotalWorkload();
        updateAllCheckboxState();
      });
    });

    // カスタム工数inputの変更を監視
    workloadInputs.forEach(input => {
      // 'change'イベントよりもリアルタイムに反応する'input'イベントを使用
      input.addEventListener('input', () => {
        calculateTotalWorkload(); // 値が変更されるたびに合計を再計算
      });
    });

    // --- 初期化処理 ---

    // ページロード時に一度、合計工数を計算して表示
    calculateTotalWorkload();
    // ページロード時に全選択チェックボックスの状態を初期化
    updateAllCheckboxState();

  } // end if (userPracticesTable)
});